import { deleteRequest } from '@/core';
import { unknownItems } from '@/requests';

export default async function deleteItemRequest(idToDelete) {
	let url = unknownItems.getByIdPath(idToDelete);
	return deleteRequest(url);
}